module.exports = __webpack_public_path__ + "static/media/scroll3_5_3.1eb0fb59.png";